import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    POSITION: 'سمت',
    GRADUATED: 'فارغ التحصیل رشته',
    DOWNLOAD_CV: 'دریافت فایل روزمه',
    NOT_FOUND: 'موردی یافت نشد',
    NO_OPTIONS: 'موردی یافت نشد',
    FIELDS: {
      FULL_NAME: {LABEL: 'نام و نام خانوادگی'},
      COLLEGES: {LABEL: 'دانشکده‌ها', PLACEHOLDER: 'انتخاب کنید'},
      GROUPS: {LABEL: 'گروه‌های آموزشی', PLACEHOLDER: 'انتخاب کنید'},
    },
  },
  [LOCALES.EN]: {
    POSITION: 'Position',
    GRADUATED: 'Graduated',
    DOWNLOAD_CV: 'Download CV',
    NOT_FOUND: 'Not Found',
    NO_OPTIONS: 'No Options',
    FIELDS: {
      FULL_NAME: { LABEL: 'Full Name' },
      COLLEGES: { LABEL: 'Colleges', PLACEHOLDER: 'Select' },
      GROUPS: { LABEL: 'Groups', PLACEHOLDER: 'Select' },
    },
  },
} as const;

export default translation;
